import bgImg from '../src/assets/img/bg.jpg';

const colors = {
  primary: '#2D2B57', // Color for buttons or links
  bg: 'white', // Background color
  accent: '#FAD000',
  purple: '#7b00ef',
  grey: {
    dark: 'rgba(0, 0, 0, 0.9)',
    default: 'rgba(0, 0, 0, 0.7)',
    light: 'rgba(0, 0, 0, 0.5)',
    ultraLight: 'rgba(0, 0, 0, 0.25)',
  },
};

const transitions = {
  normal: '0.5s',
};

const fontSize = {
  small: '0.9rem',
};

const theme = {
  colors,
  transitions,
  fontSize,
  bgImg,
};

export default theme;
